export const sessionInitialized = (state) => !!state.session.sessionInfo.sessionId;

